import { AdminSiteEmployeeRequestOrderPage } from '@/modules/employee-request-order/pages/AdminSiteEmployeeRequestOrderPage/AdminSiteEmployeeRequestOrderPage';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(
  AdminSiteEmployeeRequestOrderPage,
  { requiresEvery: [RouteRestrictions.ADMIN_ROLE] },
  { requiresMemberManagement: true }
);
